<template>
  <!--
    @name: GoApp.vue
    @description:
    @author:  GaoYu
    @time: 2020/7/28 13:13
  -->
  <span @click="openApp" :disabled="goAppBtnDisabled">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: "GoApp",
  props: {
    appUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      goAppBtnDisabled: false
    };
  },
  computed: {
    isWechatOpen() {
      let u = navigator.userAgent;
      if (/MicroMessenger/gi.test(u)) {
        return true;
      }
      return false;
    }
  },
  mounted() {},
  methods: {
    openApp() {
      this.goAppBtnDisabled = true;
      setTimeout(() => {
        this.goAppBtnDisabled = false;
      }, 1000);
      let u = navigator.userAgent;
      if (this.isWechatOpen) {
        if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
          // this.$toast('点击右上角，复制链接在浏览器打开')
          this.$toast({
            // message: '点击右上角，复制链接在浏览器打开',
            message: "点击右上角“···”，在菜单中点击浏览器打开，即可安装APP查看", // 20211102修改文案
            position: "middle",
            className: "inexa",
            duration: 5000
          });
        } else if (u.indexOf("iPhone") > -1) {
          // window.location.href =
          //   "https://apps.apple.com/cn/app/%E7%94%B5%E5%AD%90%E6%98%9F%E7%90%83/id1435866519";
          this.$toast({
            // message: '点击右上角，复制链接在浏览器打开',
            message: "点击右上角“···”，在菜单中点击浏览器打开，即可安装APP查看", // 20211102修改文案
            position: "middle",
            className: "inexa",
            duration: 5000
          });
        } else {
          this.$toast({
            message: "请在浏览器打开",
            position: "top",
            className: "inexa"
          });
        }
      } else {
        window.location.href = this.appUrl;
        let t = setTimeout(() => {
          if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
            window.location.href =
              "https://api.eestar.com/apk/eestar.apk?t=" + new Date().getTime();
          } else if (u.indexOf("iPhone") > -1) {
            window.location.href =
              "https://apps.apple.com/cn/app/%E7%94%B5%E5%AD%90%E6%98%9F%E7%90%83/id1435866519";
          }
        }, 150);
        // 2025年0327修改刷新页面防止 ios两次打开
        setTimeout(() => {
          window.location.reload();
        }, 250);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.inexa {
  z-index: 1000 !important;
}
// .go-app-container {
//   .van-button {
//     width: 100%;
//     height: 40px;
//     display: block;
//     background: rgba(117, 58, 183, 1);
//     box-shadow: 0 0 5px 0 rgba(117, 58, 183, 1);
//     border-radius: 20px;
//     border: none;
//     outline: none;
//     margin: 0 auto;
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/Common/GoApp.vue